export default "__VITE_ASSET__BPHuwleA__"